// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dimension/components/HolesConfigurationB/styles.scss
// module id = 1313
// module chunks = 0